import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import { Link, Typography } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const openAdminPanelMessage = defineMessage({
  id: 'fleet.devices.card.openAdminPanel',
  defaultMessage: 'Abrir panel de administración',
});

/**
 * External admin URL link shown on AirNode device cards.
 */
export function BalenaDevicePublicUrlLink({ publicUrl }: { publicUrl: string }) {
  const { $t } = useIntl();

  return (
    <Link
      href={publicUrl.startsWith('http') ? publicUrl : `https://${publicUrl}`}
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        typography: 'caption',
        fontWeight: 500,
        color: 'primary.main',
        mb: 1.5,
        minWidth: 0,
      }}
    >
      <DisplaySettingsIcon sx={{ fontSize: 14, flexShrink: 0 }} />
      <Typography
        component="span"
        variant="caption"
        fontWeight={500}
        noWrap
        sx={{ color: 'inherit' }}
      >
        {$t(openAdminPanelMessage)}
      </Typography>
    </Link>
  );
}
